// React 18+ findDOMNode polyfill for Swiper.js compatibility
// This addresses the deprecation warning in React 18+

if (typeof window !== "undefined") {
  // Only run on client side
  // Use dynamic import to avoid ESLint no-require-imports error
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const ReactDOM = require("react-dom");

  // Check if findDOMNode is missing (React 18+)
  if (!ReactDOM.findDOMNode) {
    // Provide a basic polyfill
    ReactDOM.findDOMNode = (instance: any) => {
      // If null or undefined, return null
      if (!instance) return null;

      // If it's already a DOM element, return it
      if (instance.nodeType) return instance;

      // For React components, try to find the underlying DOM node
      // This is a simplified implementation for Swiper compatibility
      if (instance.current) {
        // It's likely a ref
        return instance.current;
      }

      // Return null as fallback
      return null;
    };
  }

  // Suppress the warning by overriding console.error temporarily
  const originalConsoleError = console.error;
  console.error = (...args: any[]) => {
    // Filter out findDOMNode deprecation warnings
    if (
      args.length > 0 &&
      typeof args[0] === "string" &&
      (args[0].includes("findDOMNode is deprecated") ||
        args[0].includes("findDOMNode was passed an instance"))
    ) {
      return; // Suppress this specific warning
    }
    // Allow other console.error calls to pass through
    originalConsoleError.apply(console, args);
  };
}

export {};
